export default __webpack_public_path__ + "static/media/BREAKOUT ROOMS-LABEL.751ccda2.png";